
import { useLoader } from "./apiLoader";
import Backdrop from "@mui/material/Backdrop";
import { Box } from "@mui/material";
// import CircularProgress from "@mui/material/CircularProgress";
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
const GlobalLoader = () => {
  const loader = useLoader();

  return (
    <Backdrop open={loader} sx={{ color: "#fff", zIndex: 9999 }}>
      {/* <CircularProgress color="inherit" /> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          transform: "scale(1.4)",
          zIndex: 9999,
          backgroundImage: `url(${VISUALIZE__URL}+"link.mp4")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "50px 50px", // Set image size to 50px width and height
          backgroundColor: "#fff",
          opacity: 0.5,
        }}
      ></Box>
    </Backdrop>
  );
};

export default GlobalLoader;
